import React from "react";
import { useTranslation } from "react-i18next";
import "./BusinessInfo.css"; // Import CSS file for styling

function BusinessInfo() {
  const { t } = useTranslation();

  return (
    <section className="business-info">
      {/* Paragraph #1 */}
      <article className="business-info__section">
        <h1 className="business-info__header">{t("header.businessName")}</h1>
        <p className="business-info__text">{t("info.paragraph1")}</p>
        <p className="business-info__text">{t("info.paragraph2")}</p>
        {/* Video #1 */}
        <div className="business-info__video-container">
          <video className="business-info__video" controls>
            <source src="/content/video/1.mp4" type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
        </div>
      </article>

      {/* Paragraph #2 */}
      <article className="business-info__section">
        <h1 className="business-info__header">{t("info.paragraph3.1")}</h1>
        <p className="business-info__text">{t("info.paragraph3.2")}</p>
        <p className="business-info__text">{t("info.paragraph4")}</p>
        {/* Video #2 */}
        <div className="business-info__video-container">
          <video className="business-info__video" controls>
            <source src="/content/video/2.mp4" type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
        </div>
      </article>

      {/* Paragraph #3 */}
      <article className="business-info__section">
        <h1 className="business-info__header">{t("info.paragraph5.1")}</h1>
        <p className="business-info__text">{t("info.paragraph5.2")}</p>
        <p className="business-info__text">{t("info.paragraph6")}</p>
        <p className="business-info__text">{t("info.paragraph7")}</p>
        {/* Video #3 */}
        <div className="business-info__video-container">
          <video className="business-info__video" controls>
            <source src="/content/video/3.mp4" type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
        </div>
        <p className="business-info__header">{t("info.paragraph8")}</p>
      </article>
    </section>
  );
}

export default BusinessInfo;
